import React, { useState, useEffect, useRef } from 'react';
import {
  FaCopy,
  FaCheck,
  FaChevronDown,
  FaBolt,
  FaPercentage,
  FaGlobeAmericas,
  FaWallet,
  FaEye,
  FaShieldAlt,
  FaArrowUp,
  FaArrowDown,
} from 'react-icons/fa';
import MoonLogo from '../components/MoonLogo';

const MOON_REF_LINK = 'https://t.ly/MoonGiris';
const REF_CODE = 'SAGUEX';
const CYAN = '#1AD4FF';
const CYAN_LIGHT = '#4DE0FF';
const CYAN_DARK = '#009ACA';
const CYAN_TEXT_ON = '#011825';

const formatUSD = (n) =>
  `$${n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const INITIAL_ASSETS = [
  { symbol: 'BTC', name: 'Bitcoin', price: 78841.27, change: 0.92, color: '#F7931A' },
  { symbol: 'ETH', name: 'Ethereum', price: 2476.09, change: 0.28, color: '#8A92B2' },
  { symbol: 'SOL', name: 'Solana', price: 98.6, change: 3.19, color: '#14F195' },
  { symbol: 'XRP', name: 'Ripple', price: 1.478, change: 0.66, color: '#345D9D' },
  { symbol: 'DOGE', name: 'Dogecoin', price: 0.0902, change: -1.85, color: '#C2A633' },
  { symbol: 'BNB', name: 'BNB', price: 612.4, change: 0.41, color: '#F3BA2F' },
  { symbol: 'XAU', name: 'Altın', price: 4624.67, change: 0.17, color: '#D4AF37' },
  { symbol: 'TSLA', name: 'Tesla', price: 330.55, change: -1.35, color: '#E31937' },
];

const STEPS = [
  {
    n: '01',
    title: 'Referans linkiyle kayıt ol',
    desc: `Aşağıdaki butondan Moon.com'a git ve hesabını oluştur. Linkten girersen referans alanına ${REF_CODE} kodu otomatik tanımlanır.`,
  },
  {
    n: '02',
    title: 'Kripto ile bakiye yükle',
    desc: 'USDT, BTC, ETH veya SOL ağları üzerinden cüzdanından transfer yap. Bakiyen zincir onayının ardından hesabına yansır.',
  },
  {
    n: '03',
    title: 'Yönünü ve kaldıracını seç',
    desc: 'Bir varlık seç, bahis tutarını gir, kaldıracını 1x-1000x arasında ayarla ve Yukarı ya da Aşağı butonuna bas.',
  },
  {
    n: '04',
    title: 'Pozisyonunu takip et',
    desc: 'Açtığın pozisyon canlı akışta görünür. Kâr/zararını ve tasfiye seviyeni Moon panelinden anlık olarak izleyebilirsin.',
  },
];

const FEATURES = [
  {
    icon: FaBolt,
    title: "1000x'e kadar kaldıraç",
    desc: 'Küçük bir tutarla büyük pozisyon açarsın. Kaybın her zaman yatırdığın bahis tutarıyla sınırlıdır, eksi bakiye riski yoktur.',
  },
  {
    icon: FaPercentage,
    title: 'Sektörün en düşük ücretleri',
    desc: "Ücret yalnızca bahis tutarının %1'i olarak alınır; kaldıraçlı pozisyonun tamamı üzerinden değil. Ücret bahis fişinde açıkça gösterilir.",
  },
  {
    icon: FaGlobeAmericas,
    title: '7/24 açık piyasalar',
    desc: 'Kripto piyasaları hiç kapanmaz. Hisse senedi ve emtia dahil onlarca varlıkta günün her saati pozisyon açabilirsin.',
  },
  {
    icon: FaWallet,
    title: 'Anında kripto işlemler',
    desc: 'USDT, BTC, ETH ve SOL ile yatırım yap, aynı hızla çek. Bekleyen gün sonu işlemi yoktur.',
  },
  {
    icon: FaEye,
    title: 'Herkese açık bahis akışı',
    desc: 'Tüm bahisler, çarpanlar ve kâr/zarar durumları canlı akışta görünür; kimin ne yaptığı şeffaftır.',
  },
  {
    icon: FaShieldAlt,
    title: 'Risk ayarları senin elinde',
    desc: 'Pozisyon açmadan önce otomatik kâr al ve otomatik zarar durdur limitlerini kendin belirleyebilirsin.',
  },
];

const FAQS = [
  {
    q: 'Moon.com nedir?',
    a: 'Moon.com, kripto paraların ve hisse senetlerinin kısa vadeli fiyat yönü üzerine kaldıraçlı bahis oynayabildiğin bir tahmin platformudur. Klasik bir casino veya spor bahis sitesinden farklı olarak tek bir soru vardır: fiyat yukarı mı gidecek, aşağı mı?',
  },
  {
    q: 'Kaldıraç tam olarak ne işe yarar?',
    a: "Kaldıraç, fiyat hareketinin kâr ya da zararına ne kadar büyütülerek yansıyacağını belirler. Örneğin 100x kaldıraçta fiyattaki %1'lik hareket pozisyonunu iki katına çıkarabilir; ters yöndeki %1'lik hareket ise pozisyonu tasfiye edebilir. Yüksek kaldıraç yüksek risk demektir.",
  },
  {
    q: 'Bahis tutarımdan fazlasını kaybedebilir miyim?',
    a: 'Hayır. Fiyat tasfiye seviyesine ulaştığında pozisyon otomatik olarak kapanır ve yalnızca o pozisyona ayırdığın tutarı kaybedersin; ek borç ya da eksi bakiye riski oluşmaz.',
  },
  {
    q: 'Referans kodunu nereye yazmam gerekiyor?',
    a: `Bu sayfadaki referans linkinden kayıt olursan ${REF_CODE} kodu otomatik tanımlanır. Manuel kayıt oluyorsan kayıt formundaki referans alanına ${REF_CODE} yazman yeterlidir.`,
  },
  {
    q: 'Para yatırma ve çekme nasıl yapılıyor?',
    a: 'Moon kripto tabanlı çalışan bir platformdur. USDT, BTC, ETH ve SOL ağları üzerinden yatırım yapabilir, kazancını aynı ağlar üzerinden cüzdanına çekebilirsin. İşlemler zincir onayı ile birlikte hesabına yansır.',
  },
  {
    q: 'Moon liderlik tablosu nasıl çalışıyor?',
    a: 'Platformdaki bahisler herkese açık akışta ve liderlik tablosunda listelenir. En yüksek çarpanı yakalayan, en çok hacim yapan ve en çok kâr eden kullanıcılar tabloya yansır.',
  },
];

const TrustPill = ({ children }) => (
  <div
    className="flex items-center gap-2 rounded-full border px-3.5 py-2 text-xs sm:text-sm font-semibold text-white/85 backdrop-blur-sm"
    style={{ borderColor: 'rgba(26,212,255,0.25)', backgroundColor: 'rgba(26,212,255,0.06)' }}
  >
    <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: CYAN }} />
    {children}
  </div>
);

const StepCard = ({ n, title, desc }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-6 backdrop-blur-sm transition-all duration-300 hover:border-[#1AD4FF]/40 hover:bg-white/[0.05]">
    <div
      className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-xl text-sm font-black"
      style={{ backgroundColor: 'rgba(26,212,255,0.12)', color: CYAN_LIGHT, border: '1px solid rgba(26,212,255,0.3)' }}
    >
      {n}
    </div>
    <h3 className="mb-2 text-base sm:text-lg font-bold text-white">{title}</h3>
    <p className="text-sm leading-relaxed text-white/60">{desc}</p>
  </div>
);

const FeatureCard = ({ icon: Icon, title, desc }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-6 backdrop-blur-sm transition-all duration-300 hover:border-[#1AD4FF]/40 hover:bg-white/[0.05] hover:-translate-y-1">
    <div
      className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl"
      style={{ backgroundColor: 'rgba(26,212,255,0.12)', border: '1px solid rgba(26,212,255,0.3)' }}
    >
      <Icon style={{ color: CYAN_LIGHT }} className="h-5 w-5" />
    </div>
    <h3 className="mb-2 text-base sm:text-lg font-bold text-white">{title}</h3>
    <p className="text-sm leading-relaxed text-white/60">{desc}</p>
  </div>
);

const FaqItem = ({ item, isOpen, onToggle }) => (
  <div
    className="overflow-hidden rounded-2xl border transition-colors duration-300"
    style={{ borderColor: isOpen ? 'rgba(26,212,255,0.4)' : 'rgba(255,255,255,0.1)', backgroundColor: 'rgba(255,255,255,0.03)' }}
  >
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5"
    >
      <span className="text-sm sm:text-base font-semibold text-white">{item.q}</span>
      <FaChevronDown
        className={`h-4 w-4 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        style={{ color: CYAN_LIGHT }}
      />
    </button>
    <div
      className="grid transition-all duration-300 ease-out"
      style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
    >
      <div className="overflow-hidden">
        <p className="px-5 pb-5 text-sm leading-relaxed text-white/60 sm:px-6">{item.a}</p>
      </div>
    </div>
  </div>
);

const SeoBlock = ({ title, children }) => (
  <div className="mb-8">
    <h3 className="mb-2 text-lg sm:text-xl font-bold text-white">{title}</h3>
    <p className="text-sm sm:text-base leading-relaxed text-white/60">{children}</p>
  </div>
);

const MoonPage = () => {
  const [assets, setAssets] = useState(INITIAL_ASSETS);
  const [copied, setCopied] = useState(false);
  const [betAmount, setBetAmount] = useState(25);
  const [leverage, setLeverage] = useState(100);
  const [direction, setDirection] = useState('up');
  const [openFaq, setOpenFaq] = useState(0);
  const [seoExpanded, setSeoExpanded] = useState(false);
  const stepsRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setAssets((prev) =>
        prev.map((a) => ({
          ...a,
          price: a.price * (1 + (Math.random() - 0.5) * 0.002),
        }))
      );
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const btc = assets[0];
  const positionSize = betAmount * leverage;
  const fee = betAmount * 0.01;
  const liqDelta = 1 / leverage;
  const liquidationPrice =
    direction === 'up' ? btc.price * (1 - liqDelta) : btc.price * (1 + liqDelta);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(REF_CODE);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setCopied(false);
    }
  };

  const scrollToSteps = () => {
    stepsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const tickerLoop = [...assets, ...assets, ...assets];

  return (
    <div
      className="w-full overflow-x-hidden"
      style={{
        background:
          'radial-gradient(ellipse 90% 55% at 50% 0%, rgba(26,212,255,0.10), transparent 60%), linear-gradient(180deg, #01121C 0%, #050b14 55%, #071019 100%)',
      }}
    >
      {/* Hero */}
      <section className="relative mx-auto max-w-7xl px-4 pb-14 pt-10 sm:pt-14 sm:pb-20">
        <div
          className="pointer-events-none absolute -top-20 right-0 h-72 w-72 rounded-full blur-3xl sm:h-96 sm:w-96"
          style={{ backgroundColor: 'rgba(26,212,255,0.12)' }}
        />
        <div className="relative grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-10">
          {/* Left column */}
          <div>
            <div className="mb-5 flex flex-wrap items-center gap-3">
              <MoonLogo size="md" />
              <span className="text-sm font-semibold text-white/40">×</span>
              <span className="text-sm font-bold uppercase tracking-wider text-white/70">SAGUEX</span>
            </div>

            <div
              className="mb-5 inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider"
              style={{ borderColor: 'rgba(26,212,255,0.35)', backgroundColor: 'rgba(26,212,255,0.1)', color: CYAN_LIGHT }}
            >
              Resmi Sponsorluk Partneri
            </div>

            <h1 className="mb-5 text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
              Fiyatın yönünü tahmin et,{' '}
              <span style={{ color: CYAN_LIGHT }}>1000x</span> kaldıraçla kazan
            </h1>

            <p className="mb-6 max-w-xl text-sm leading-relaxed text-white/60 sm:text-base">
              Moon.com; Bitcoin, Ethereum, Solana ve Tesla gibi varlıkların kısa vadeli yönü üzerine
              bahis oynadığın kaldıraçlı bahis platformu. SAGUEX'in resmi sponsorluk partneri —
              referans kodumuzla saniyeler içinde kayıt olabilirsin.
            </p>

            <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <span className="text-xs font-semibold uppercase tracking-wider text-white/45">
                Referans kodu
              </span>
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex items-center gap-2.5 rounded-xl border px-4 py-2.5 text-sm font-bold tracking-wide transition-all duration-300"
                style={{
                  borderColor: 'rgba(26,212,255,0.4)',
                  backgroundColor: 'rgba(26,212,255,0.08)',
                  color: CYAN_LIGHT,
                }}
              >
                {REF_CODE}
                {copied ? <FaCheck className="h-3.5 w-3.5" /> : <FaCopy className="h-3.5 w-3.5" />}
              </button>
              {copied && <span className="text-xs font-medium text-emerald-400">Kopyalandı!</span>}
            </div>

            <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <a
                href={MOON_REF_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-xl px-7 py-3.5 text-sm font-bold shadow-lg transition-transform duration-300 hover:scale-[1.02]"
                style={{
                  backgroundImage: `linear-gradient(143deg, ${CYAN} 10%, ${CYAN_DARK} 80%)`,
                  color: CYAN_TEXT_ON,
                  boxShadow: '0 10px 25px rgba(1,153,202,0.35)',
                }}
              >
                Moon'a Kayıt Ol
              </a>
              <button
                type="button"
                onClick={scrollToSteps}
                className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-7 py-3.5 text-sm font-bold text-white/85 transition-colors duration-300 hover:bg-white/10"
              >
                Nasıl çalışır?
              </button>
            </div>

            <div className="flex flex-wrap gap-2.5">
              <TrustPill>1x - 1000x kaldıraç</TrustPill>
              <TrustPill>Sektörün en düşük ücretleri</TrustPill>
              <TrustPill>7/24 açık piyasalar</TrustPill>
            </div>
          </div>

          {/* Right column: Demo bet slip */}
          <div className="relative">
            <div
              className="rounded-3xl border p-5 shadow-2xl backdrop-blur-md sm:p-6"
              style={{ borderColor: 'rgba(26,212,255,0.25)', backgroundColor: 'rgba(4,16,26,0.75)' }}
            >
              <div className="mb-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span
                    className="flex h-10 w-10 items-center justify-center rounded-full text-xs font-black text-white"
                    style={{ backgroundColor: btc.color }}
                  >
                    ₿
                  </span>
                  <div>
                    <div className="text-sm font-bold text-white">{btc.symbol}</div>
                    <div className="text-[11px] text-white/45">{btc.name}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-base font-bold tabular-nums text-white">{formatUSD(btc.price)}</div>
                  <div className={`text-xs font-semibold ${btc.change >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                    {btc.change >= 0 ? '+' : ''}
                    {btc.change.toFixed(2)}%
                  </div>
                </div>
              </div>

              <div
                className="mb-4 rounded-full px-3 py-1 text-center text-[10px] font-bold uppercase tracking-widest"
                style={{ backgroundColor: 'rgba(26,212,255,0.1)', color: CYAN_LIGHT }}
              >
                Demo Bahis Fişi
              </div>

              <div className="mb-4">
                <label className="mb-1.5 block text-xs font-semibold text-white/50">Bahis tutarı</label>
                <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-black/30 px-4 py-2.5">
                  <span className="text-white/50">$</span>
                  <input
                    type="number"
                    min="1"
                    value={betAmount}
                    onChange={(e) => setBetAmount(Math.max(1, Number(e.target.value) || 0))}
                    className="w-full bg-transparent text-sm font-bold tabular-nums text-white outline-none"
                  />
                </div>
              </div>

              <div className="mb-5">
                <div className="mb-1.5 flex items-center justify-between text-xs font-semibold text-white/50">
                  <span>Kaldıraç</span>
                  <span style={{ color: CYAN_LIGHT }} className="font-bold">{leverage}x</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="1000"
                  value={leverage}
                  onChange={(e) => setLeverage(Number(e.target.value))}
                  className="w-full accent-[#1AD4FF]"
                />
                <div className="mt-1 flex justify-between text-[10px] text-white/35">
                  <span>1x</span>
                  <span>250x</span>
                  <span>500x</span>
                  <span>1000x</span>
                </div>
              </div>

              <div className="mb-5 grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => setDirection('up')}
                  className={`flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold transition-all duration-200 ${
                    direction === 'up'
                      ? 'bg-emerald-500 text-black shadow-lg shadow-emerald-500/30'
                      : 'border border-white/10 bg-white/5 text-white/60 hover:bg-white/10'
                  }`}
                >
                  <FaArrowUp className="h-3.5 w-3.5" /> Yukarı
                </button>
                <button
                  type="button"
                  onClick={() => setDirection('down')}
                  className={`flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold transition-all duration-200 ${
                    direction === 'down'
                      ? 'bg-red-500 text-white shadow-lg shadow-red-500/30'
                      : 'border border-white/10 bg-white/5 text-white/60 hover:bg-white/10'
                  }`}
                >
                  <FaArrowDown className="h-3.5 w-3.5" /> Aşağı
                </button>
              </div>

              <div className="mb-5 space-y-2 rounded-xl border border-white/10 bg-black/20 p-4 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-white/50">Pozisyon büyüklüğü</span>
                  <span className="font-bold tabular-nums text-white">{formatUSD(positionSize)}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-white/50">Tasfiye fiyatı</span>
                  <span className="font-bold tabular-nums text-red-400">{formatUSD(liquidationPrice)}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-white/50">Tahmini ücret</span>
                  <span className="font-bold tabular-nums text-white">{formatUSD(fee)}</span>
                </div>
              </div>

              <p className="mb-5 text-[11px] leading-relaxed text-white/35">
                Ücret, kaldıraçlı toplam üzerinden değil; yalnızca bahis tutarının %1'i olarak alınır.
              </p>

              <a
                href={MOON_REF_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center rounded-xl py-3.5 text-sm font-bold shadow-lg transition-transform duration-300 hover:scale-[1.01]"
                style={{
                  backgroundImage: `linear-gradient(143deg, ${CYAN} 10%, ${CYAN_DARK} 80%)`,
                  color: CYAN_TEXT_ON,
                  boxShadow: '0 10px 25px rgba(1,153,202,0.35)',
                }}
              >
                Moon'da gerçek bahis aç
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Ticker marquee */}
      <section className="relative overflow-hidden border-y border-white/10 bg-black/30 py-4">
        <div className="flex w-max animate-scroll-infinite">
          {tickerLoop.map((a, i) => (
            <div key={`${a.symbol}-${i}`} className="mx-5 flex flex-shrink-0 items-center gap-2.5">
              <span
                className="flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-black text-white"
                style={{ backgroundColor: a.color }}
              >
                {a.symbol[0]}
              </span>
              <span className="text-sm font-bold text-white">{a.symbol}</span>
              <span className="text-sm font-semibold tabular-nums text-white/70">{formatUSD(a.price)}</span>
              <span className={`text-xs font-bold ${a.change >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {a.change >= 0 ? '+' : ''}
                {a.change.toFixed(2)}%
              </span>
            </div>
          ))}
        </div>
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#050b14] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#050b14] to-transparent" />
        <p className="mt-3 text-center text-[11px] text-white/30">
          Temsili fiyat akışı. Canlı fiyatlar Moon.com üzerindedir.
        </p>
      </section>

      {/* 4 steps */}
      <section ref={stepsRef} className="mx-auto max-w-7xl px-4 py-16 sm:py-20 scroll-mt-24">
        <div className="mb-10 text-center sm:mb-12">
          <h2 className="mb-3 text-2xl font-extrabold text-white sm:text-3xl lg:text-4xl">
            4 adımda Moon'a başla
          </h2>
          <p className="text-sm text-white/50 sm:text-base">
            Kayıttan ilk bahsine kadar tüm süreç birkaç dakika sürer.{' '}
            <span style={{ color: CYAN_LIGHT }} className="font-semibold">
              Ortalama süre: 3-5 dakika
            </span>
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4">
          {STEPS.map((s) => (
            <StepCard key={s.n} {...s} />
          ))}
        </div>
      </section>

      {/* Features */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:py-20">
        <div className="mb-10 text-center sm:mb-12">
          <h2 className="mb-3 text-2xl font-extrabold text-white sm:text-3xl lg:text-4xl">
            Moon'u farklı kılan ne?
          </h2>
          <p className="text-sm text-white/50 sm:text-base">
            Klasik casino mantığı yok; tek soru var: yukarı mı, aşağı mı?
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3">
          {FEATURES.map((f) => (
            <FeatureCard key={f.title} {...f} />
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-4xl px-4 py-16 sm:py-20">
        <div className="mb-10 text-center sm:mb-12">
          <h2 className="mb-3 text-2xl font-extrabold text-white sm:text-3xl lg:text-4xl">
            Sık sorulan sorular
          </h2>
          <p className="text-sm text-white/50 sm:text-base">Moon hakkında en çok merak edilenler.</p>
        </div>
        <div className="space-y-3">
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              isOpen={openFaq === i}
              onToggle={() => setOpenFaq(openFaq === i ? -1 : i)}
            />
          ))}
        </div>
      </section>

      {/* SEO long-form content */}
      <section className="mx-auto max-w-4xl px-4 pb-20">
        <div
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.02] p-6 sm:p-8"
          style={{ maxHeight: seoExpanded ? 'none' : '340px' }}
        >
          <SeoBlock title="Moon.com Nedir? Kaldıraçlı Kripto ve Hisse Bahis Platformu">
            Moon.com, kripto paraların ve hisse senetlerinin kısa vadeli fiyat yönü üzerine bahis
            oynayabildiğin, kaldıraçlı bir tahmin platformudur. Klasik bir casino ya da spor bahis
            sitesinden farklı olarak Moon'da tek bir soru vardır: fiyat yukarı mı gidecek, aşağı mı?
            Doğru tahmin ettiğinde kaldıraç oranın kadar çarpanla kazanırsın.
          </SeoBlock>
          <SeoBlock title="Moon.com Nasıl Çalışır?">
            Bir varlık seçersin (Bitcoin, Ethereum, Solana, XRP, altın ya da Tesla, Apple gibi
            hisseler), bahis tutarını girersin, kaldıracını 1x ile 1000x arasında ayarlarsın ve yön
            seçersin. Fiyat senin yönünde hareket ettikçe pozisyonun büyür; ters yönde hareket edip
            tasfiye fiyatına ulaşırsa yalnızca yatırdığın tutarı kaybedersin. Ek borç ya da eksi
            bakiye riski yoktur — kaybın her zaman bahis tutarınla sınırlıdır.
          </SeoBlock>
          {seoExpanded && (
            <>
              <SeoBlock title="Moon Kaldıraç Nedir?">
                Kaldıraç, fiyat hareketinin kâr/zararına ne kadar büyütülerek yansıyacağını belirler.
                100x kaldıraçta fiyatın %1 hareket etmesi pozisyonunu iki katına çıkarabilir; aynı
                şekilde %1'lik ters hareket pozisyonu tasfiye edebilir. Yüksek kaldıraç yüksek risk
                demektir; küçük tutarlarla başlamak en mantıklısıdır.
              </SeoBlock>
              <SeoBlock title="Moon Güncel Giriş">
                Moon platformuna SAGUEX referans linki üzerinden erişebilirsin. Linkten girdiğinde
                referans kodu otomatik tanımlanır; manuel kayıt oluyorsan referans alanına {REF_CODE}{' '}
                yazman yeterlidir.
              </SeoBlock>
              <SeoBlock title="Moon Para Yatırma ve Çekme">
                Moon kripto tabanlı bir platformdur. USDT, Bitcoin, Ethereum ve Solana gibi ağlar
                üzerinden yatırım yapabilir, kazancını aynı şekilde cüzdanına çekebilirsin. İşlemler
                zincir üzerinde onaylandığı anda bakiyene yansır; bekleme süresi büyük ölçüde
                seçtiğin ağa bağlıdır.
              </SeoBlock>
              <SeoBlock title="Moon Ücretleri">
                Moon, sektörün en düşük açılış ücretlerinden birini sunar. En kritik fark şudur:
                ücret, kaldıraçlı pozisyonun tamamı üzerinden değil, yalnızca senin yatırdığın bahis
                tutarı üzerinden alınır ve oranı %1'dir. Örneğin $50.000 bahis tutarına 150x kaldıraç
                uygularsan pozisyon büyüklüğün $7.500.000 olur; ödediğin ücret ise bunun değil,
                $50.000'ın %1'i olan $500'dır. Ücret bahis fişinde açıkça gösterilir; gizli komisyon
                ya da çekim ücreti sürprizi yoktur.
              </SeoBlock>
              <SeoBlock title="Moon Liderlik Tablosu">
                Platformdaki tüm bahisler herkese açık akışta ve liderlik tablosunda görünür. En
                yüksek çarpanı yakalayan, en çok hacim yapan ve en çok kâr eden kullanıcılar burada
                listelenir. Kendi sıranı ve gün içindeki büyük kazançları buradan canlı olarak takip
                edebilirsin.
              </SeoBlock>
              <SeoBlock title="Moon ve Sorumlu Oyun">
                Kaldıraçlı bahis yüksek risk içerir. Yalnızca kaybetmeyi göze alabileceğin
                tutarlarla oyna, kayıp kovalama ve risk ayarları bölümünden otomatik kâr/zarar
                limitlerini mutlaka kullan. Moon 18 yaş altı kullanıcılara hizmet vermez.
              </SeoBlock>
            </>
          )}
          {!seoExpanded && (
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#050b14] to-transparent" />
          )}
        </div>
        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={() => setSeoExpanded((v) => !v)}
            className="inline-flex items-center gap-2 rounded-xl border border-white/15 bg-white/5 px-6 py-3 text-xs font-bold uppercase tracking-wider text-white/80 transition-colors hover:bg-white/10"
          >
            {seoExpanded ? 'Daha Az Göster' : 'Daha Fazla Göster'}
            <FaChevronDown className={`h-3 w-3 transition-transform ${seoExpanded ? 'rotate-180' : ''}`} />
          </button>
        </div>
      </section>

      {/* Final CTA */}
      <section className="mx-auto max-w-5xl px-4 pb-20">
        <div
          className="flex flex-col items-center gap-5 rounded-3xl border p-8 text-center sm:p-12"
          style={{ borderColor: 'rgba(26,212,255,0.3)', background: 'linear-gradient(135deg, rgba(26,212,255,0.1), rgba(1,18,28,0.4))' }}
        >
          <MoonLogo size="md" />
          <h2 className="text-xl font-extrabold text-white sm:text-2xl">
            {REF_CODE} kodu ile Moon.com'da hemen kayıt ol
          </h2>
          <p className="max-w-lg text-sm text-white/60">
            Referans linkinden kayıt olduğunda kod otomatik tanımlanır, saniyeler içinde ilk
            pozisyonunu açabilirsin.
          </p>
          <a
            href={MOON_REF_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-xl px-8 py-3.5 text-sm font-bold shadow-lg transition-transform duration-300 hover:scale-[1.02]"
            style={{
              backgroundImage: `linear-gradient(143deg, ${CYAN} 10%, ${CYAN_DARK} 80%)`,
              color: CYAN_TEXT_ON,
              boxShadow: '0 10px 25px rgba(1,153,202,0.35)',
            }}
          >
            Moon'a Kayıt Ol
          </a>
        </div>
      </section>
    </div>
  );
};

export default MoonPage;
